<template>
  <svg
    version="1.1"
    viewBox="0 0 274.06 86.374"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
  >
    <defs>
      <clipPath id="b">
        <path transform="translate(-282.57 -413.68)" d="M 0,841.89 H 595.276 V 0 H 0 Z" />
      </clipPath>
      <clipPath id="a">
        <path transform="translate(-293.07 -413.68)" d="M 0,841.89 H 595.276 V 0 H 0 Z" />
      </clipPath>
      <clipPath id="m">
        <path transform="translate(-303.56 -413.68)" d="M 0,841.89 H 595.276 V 0 H 0 Z" />
      </clipPath>
      <clipPath id="l">
        <path transform="translate(-314.05 -413.68)" d="M 0,841.89 H 595.276 V 0 H 0 Z" />
      </clipPath>
      <clipPath id="k">
        <path transform="translate(-324.55 -413.68)" d="M 0,841.89 H 595.276 V 0 H 0 Z" />
      </clipPath>
      <clipPath id="j">
        <path transform="translate(-346.64 -389.47)" d="M 0,841.89 H 595.276 V 0 H 0 Z" />
      </clipPath>
      <clipPath id="i">
        <path transform="translate(-377.07 -401.76)" d="M 0,841.89 H 595.276 V 0 H 0 Z" />
      </clipPath>
      <clipPath id="h">
        <path transform="translate(-383.53 -413.99)" d="M 0,841.89 H 595.276 V 0 H 0 Z" />
      </clipPath>
      <clipPath id="g">
        <path transform="translate(-357.01 -425.74)" d="M 0,841.89 H 595.276 V 0 H 0 Z" />
      </clipPath>
      <clipPath id="f">
        <path transform="translate(-381.44 -438.67)" d="M 0,841.89 H 595.276 V 0 H 0 Z" />
      </clipPath>
      <clipPath id="e">
        <path transform="translate(-440.55 -405.96)" d="M 0,841.89 H 595.276 V 0 H 0 Z" />
      </clipPath>
      <clipPath id="d">
        <path transform="translate(-345.3 -452.24)" d="M 0,841.89 H 595.276 V 0 H 0 Z" />
      </clipPath>
      <clipPath id="c">
        <path transform="translate(-388.88 -389.47)" d="M 0,841.89 H 595.276 V 0 H 0 Z" />
      </clipPath>
    </defs>
    <g
      transform="translate(-342.02 -518.2)"
      fill="none"
      stroke="#0072ce"
      stroke-miterlimit="10"
      stroke-width="2"
    >
      <path transform="matrix(1.3333 0 0 -1.3333 342.02 603.23)" d="m0 0h205.55" />
      <path transform="matrix(1.3333 0 0 -1.3333 452.57 586.84)" d="m0 0h56.244" />
      <path transform="matrix(1.3333 0 0 -1.3333 432.73 570.43)" d="m0 0h76.369" />
      <path transform="matrix(1.3333 0 0 -1.3333 447.57 554.87)" d="m0 0h59.99" />
      <path transform="matrix(1.3333 0 0 -1.3333 436.06 537.62)" d="m0 0h69.895" />
      <path
        transform="matrix(1.3333 0 0 -1.3333 376.76 570.95)"
        d="m0 0s-0.842 2.319-5.247 2.319c-4.406 0-5.248-2.319-5.248-2.319v-24.207h10.495z"
        clip-path="url(#b)"
      />
      <path
        transform="matrix(1.3333 0 0 -1.3333 390.75 570.95)"
        d="m0 0s-0.842 2.319-5.247 2.319c-4.406 0-5.248-2.319-5.248-2.319v-24.207h10.495z"
        clip-path="url(#a)"
      />
      <path
        transform="matrix(1.3333 0 0 -1.3333 404.75 570.95)"
        d="m0 0s-0.842 2.319-5.247 2.319c-4.406 0-5.248-2.319-5.248-2.319v-24.207h10.495z"
        clip-path="url(#m)"
      />
      <path
        transform="matrix(1.3333 0 0 -1.3333 418.74 570.95)"
        d="m0 0s-0.842 2.319-5.247 2.319c-4.406 0-5.248-2.319-5.248-2.319v-24.207h10.495z"
        clip-path="url(#l)"
      />
      <path
        transform="matrix(1.3333 0 0 -1.3333 432.73 570.95)"
        d="m0 0s-0.842 2.319-5.247 2.319c-4.406 0-5.248-2.319-5.248-2.319v-24.207h10.495z"
        clip-path="url(#k)"
      />
      <path
        transform="matrix(1.3333 0 0 -1.3333 462.19 603.23)"
        d="m0 0 16.814 12.31"
        clip-path="url(#j)"
      />
      <path
        transform="matrix(1.3333 0 0 -1.3333 502.77 586.84)"
        d="m0 0-11.571 12.304"
        clip-path="url(#i)"
      />
      <path
        transform="matrix(1.3333 0 0 -1.3333 511.38 570.53)"
        d="m0 0-14.906 11.744"
        clip-path="url(#h)"
      />
      <path
        transform="matrix(1.3333 0 0 -1.3333 476.01 554.87)"
        d="m0 0 13.087 12.935"
        clip-path="url(#g)"
      />
      <path
        transform="matrix(1.3333 0 0 -1.3333 508.59 537.62)"
        d="m0 0-10.67 13.566"
        clip-path="url(#f)"
      />
      <path
        transform="matrix(1.3333 0 0 -1.3333 587.4 581.24)"
        d="m0 0-10.575 7.92v-7.92l-10.315 7.92v-7.92l-10.315 7.736v-24.24h31.205z"
        clip-path="url(#e)"
      />
      <path
        transform="matrix(1.3333 0 0 -1.3333 460.4 519.54)"
        d="m0 0v-62.768"
        clip-path="url(#d)"
      />
      <path
        transform="matrix(1.3333 0 0 -1.3333 518.5 603.23)"
        d="m0 0v62.768h-47.523"
        clip-path="url(#c)"
      />
    </g>
  </svg>
</template>
